import { FirebaseManager } from '@alfred-systems/frontend-shared-components';

// frontend-shared-components v3 requires FirebaseManager.init() before any Firebase manager is used,
// App Check is initialized inside init(), so do not call initializeAppCheck elsewhere.
FirebaseManager.init({
  FCM_API_KEY: 'AIzaSyCZnFc7Ea4BLfGTa044z3oYkuSD5UF2KuE',
  FCM_AUTH_DOMAIN: 'api-project-317780763450.firebaseapp.com',
  FCM_DATABASE_URL: 'https://api-project-317780763450.firebaseio.com',
  FCM_PROJECT_ID: 'api-project-317780763450',
  FCM_STORAGE_BUCKET: 'api-project-317780763450.appspot.com',
  FCM_MESSAGING_SENDER_ID: '317780763450',
  FCM_APP_ID: '1:317780763450:web:be60c3cf7662af679e6603',
  FCM_MEASUREMENT_ID: 'G-XWYHJRQYMY',
  RECAPTCHA_SITE_KEY: '6Lf8S2ktAAAAAOej_bhcQfDVbHS_YeYhVwOzn6pM',
  APPCHECK_DEBUG_TOKEN: process.env.REACT_APP_APPCHECK_DEBUG_TOKEN,
});
